<div class="icon-cell-container" [ngClass]="{ reverse: reverseOrder }">
  <ins-icon-container *ngFor="let icon of icons" [icon]="icon"></ins-icon-container>
  <div class="overflow-text-container">
    <ins-overflow-span
      [content]="dataToRender"
      [tooltipClass]="'long-tooltip'"
      [tooltipDisabled]="!showTextTooltip"
    ></ins-overflow-span>
  </div>
</div>
